<template>
    <div class="question-create ">
        <div v-if="action=='create'" class="section__header mb-4">
            <span class="badge  badge--accent question-count-badge">{{getTranslation('questionNo',($store.getters['test/getQuestionCount']+1))}}</span>
        </div>
        <div v-else class="section__header mb-4">
            <span class="badge  badge--accent question-count-badge">{{getTranslation('questionID')}}: {{ form.id }}</span>
        </div>
        <form @submit.prevent="save">
            <div class="question-part col-md-8">

                <div v-if="!testId">
                    <TestingSelectComponent v-model="form.testId" />
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('ru_RU') }} <span class="required">*</span></label>
                    <ckeditor :class="{'field--error':$v.form.questionRu.$error}" :editor="editorOptions.editor" v-model.trim="form.questionRu" :config="editorOptions.editorConfig" />
                    <div v-if="$v.form.questionRu.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('ky_KG') }} <span class="required">*</span> </label>
                    <ckeditor :tag-name="editorOptions.tagName" :class="{'field--error':$v.form.questionKy.$error}" :editor="editorOptions.editor" v-model.trim="form.questionKy" :config="editorOptions.editorConfig" />
                    <div v-if="$v.form.questionKy.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('questionSection') }} </label>
                    <input v-model.trim="form.section" class="field  field--full-width " />
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('questionSection') }} ({{ getTranslation('ky_KG') }}) </label>
                    <input v-model.trim="form.sectionKy" class="field  field--full-width " />
                </div>
                <div class="form__group">
                    <label class="form__label  form__label--block">{{ getTranslation('type') }} <span class="required">*</span></label>
                    <v-select
                            v-model="form.typeId"
                            :options="types"
                            :reduce="option=>option.id"
                            :placeholder="getTranslation('selectFromList')"
                            :searchable="false"
                            label="title"
                            :class="{'field--error': $v.form.typeId.$error}"
                    />
                    <div v-if="$v.form.typeId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
                </div>
                <div class="checkbox-group  form__group">
                    <label class="checkbox">
                        <input class="checkbox__input" v-model="form.status" type="checkbox" />
                        <span class="checkbox__indicator  checkbox__indicator--inline" />
                        <span class="checkbox__label">{{getTranslation('active')}}?</span>
                    </label>
                </div>
            </div>
            <div class="answer-part">
                <div class="answers">
                    <div v-if="(typeId !== QUESTION_FILL_IN) || (typeId===QUESTION_FILL_IN && answers.length<1)" class="section__header">
                        <label class="form__label  form__label--block">{{ getTranslation('answers') }}
                            <a href="javascript:void(0)" @click="addAnswer" :title="getTranslation('add')" class="btn  btn--square">
                                <svg class="btn__icon  btn__icon--sm">
                                    <use xlink:href="#icon__square-add"></use>
                                </svg>
                            </a>
                        </label>
                    </div>
                    <div class="mb-2 row">
                        <div class="section__controls-group ">
                            <button type="button" @click="$refs.avatarSelect.click()" class="btn btn--main btn--sm">
                                {{ getTranslation('Choose question figure') }}
                            </button>
                            <input @change="uploadPhoto" style="display: none" ref="avatarSelect" type="file" accept="image/*" />
                            <a class="btn btn--sm btn--light" v-if="form.photoUrl" @click="clearFile" href="javascript:void(0)">{{ getTranslation('clearFile') }}</a>
                            <span v-if="form.photoUrl && image.name" class="section__descr ml-3">( {{ image.name }} / {{ image.width }}x{{ image.height }} )</span>
                            <span class="text text--success ml-3">{{ getTranslation('fileRecommendedSize','594x350 ~ 1200x350') }}</span>
                        </div>
                    </div>
                    <div v-if="form.photoUrl" class="mb-4 col-sm-12">
                        <img :src="form.photoUrl" class="question__photo" :alt="getTranslation('questionFigure')">
                    </div>
                    <div class="section__body">
                        <div v-if="typeId === QUESTION_FILL_IN" class="fill-in-answer-part col-sm-12">
                            <div class="mb-2 col-sm-12 answer-group">
                                <div class="answer-ky">
                                    <label class="form__label  form__label--block">{{ getTranslation('True answer in russian') }} <span class="required">*</span></label>
                                    <textarea :class="{'field--error' : $v.formTrueAnswers.trueAnswerRu.$error }" class="field field--80-width" v-model.trim="form.trueAnswerRu" style="height: 50px" />
                                    <div v-if="$v.formTrueAnswers.trueAnswerRu.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
                                </div>
                                <div class="answer-ru">
                                    <label class="form__label  form__label--block">{{ getTranslation('True answer in kyrgyz language') }} <span class="required">*</span> </label>
                                    <textarea :class="{'field--error' : $v.formTrueAnswers.trueAnswerKy.$error}" class="field field--80-width" v-model.trim="form.trueAnswerKy" style="height: 50px" />
                                    <div v-if="$v.formTrueAnswers.trueAnswerKy.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
                                </div>
                            </div>
                            <div class="mb-2 col-sm-12 answer-group">
                                <div class="answer-ky">
                                    <label class="form__label  form__label--block">{{ getTranslation('Answer description in russian') }}</label>
                                    <textarea class="field field--80-width" v-model.trim="form.descriptionRu" style="height: 50px" />
                                </div>
                                <div class="answer-ru">
                                    <label class="form__label  form__label--block">{{ getTranslation('Answer description in kyrgyz language') }} </label>
                                    <textarea class="field field--80-width" v-model.trim="form.descriptionKy" style="height: 50px" />
                                </div>
                            </div>
                            <div class="fill-in-answer mb-2">
                                <div v-for="(item,key) in  answers" v-bind:key="key" class="mb-2">
                                    <div class="answer-ky row col-md-10">
                                        <label class="form__label  form__label--block">{{ getTranslation('answer_variants_in_ru') }} </label>
                                        <ckeditor :editor="editorOptions.editor" v-model.trim="item.answerRu" :config="editorOptions.editorConfig" />
                                        <div v-if="checkForInvalidAnswer(key,true)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                        <div class="answer-actions ml-3">
                                            <a :title="getTranslation('clear')" @click="clearFillinAnswers('ru')" class="btn  btn--sm btn--accent btn--control" href="javascript:void(0)">
                                                {{ getTranslation('clear') }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="answer-ky mt-3 row col-md-10">
                                        <label class="form__label  form__label--block">{{ getTranslation('answer_variants_in_ky') }} </label>
                                        <ckeditor :editor="editorOptions.editor" v-model.trim="item.answerKy" :config="editorOptions.editorConfig" />
                                        <div v-if="checkForInvalidAnswer(key,false)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                        <div class="answer-actions ml-3">
                                            <a :title="getTranslation('clear')" @click="clearFillinAnswers('ky')" class="btn  btn--sm btn--accent btn--control" href="javascript:void(0)">
                                                {{ getTranslation('clear') }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="answer-body">
                            <div v-if="typeId === QUESTION_SINGLE" class="single-answer">
                                <div v-for="(item,key) in  answers" v-bind:key="key" class="mb-2 answer-group">
                                    <div class="answer-ky">
                                        <label class="form__label  form__label--block">{{ getTranslation('answerRu') }} <span class="required">*</span></label>
                                        <textarea :class="{'field--error' : checkForInvalidAnswer(key,true) && checkAnswer }" class="field field--full-width" v-model.trim="item.answerRu" style="height: 50px" />
                                        <div v-if="checkForInvalidAnswer(key,true)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                    </div>
                                    <div class="answer-ru input-group">
                                        <label class="form__label  form__label--block">{{ getTranslation('answerKy') }} <span class="required">*</span> </label>
                                        <textarea :class="{'field--error' : checkForInvalidAnswer(key,false) && checkAnswer}" class="field field--80-width" v-model.trim="item.answerKy" style="height: 50px" />
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <label class="radio  radio--inline">
                                                    <input class="radio__input" type="radio" v-model="trueAnswer" :value="key">
                                                    <span class="radio__indicator  radio__indicator--inline" />
                                                </label>
                                            </div>
                                        </div>
                                        <div class="answer-actions ml-3">
                                            <a :title="getTranslation('delete')" @click="deleteAnswer(key)" :disabled="answers.length<3" class="btn  btn--white  btn--square" href="javascript:void(0)">
                                                <svg class="btn__icon  btn__icon--danger">
                                                    <use xlink:href="#icon__square-cross" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div v-if="checkForInvalidAnswer(key,false)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="typeId === QUESTION_MULTIPLE" class="multiple-answer">
                                <div v-for="(item,key) in  answers" v-bind:key="key" class="mb-2 answer-group">
                                    <div class="answer-ky">
                                        <label class="form__label  form__label--block">{{ getTranslation('answerRu') }} <span class="required">*</span></label>
                                        <textarea :class="{'field--error' : checkForInvalidAnswer(key,true) && checkAnswer }" class="field field--full-width" v-model.trim="item.answerRu" style="height: 50px" />
                                        <div v-if="checkForInvalidAnswer(key,true)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                    </div>
                                    <div class="answer-ru input-group">
                                        <label class="form__label  form__label--block">{{ getTranslation('answerKy') }} <span class="required">*</span> </label>
                                        <textarea :class="{'field--error' : checkForInvalidAnswer(key,false) && checkAnswer}" class="field field--80-width" v-model.trim="item.answerKy" style="height: 50px" />
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <label class="checkbox  checkbox--inline">
                                                    <input class="checkbox__input" type="checkbox" v-model="item.trueAnswer" :value="1">
                                                    <span class="checkbox__indicator  checkbox__indicator--inline" />
                                                </label>
                                            </div>
                                        </div>
                                        <div class="answer-actions ml-3">
                                            <a :title="getTranslation('delete')" @click="deleteAnswer(key)" :disabled="answers.length<4" class="btn  btn--white  btn--square" href="javascript:void(0)">
                                                <svg class="btn__icon  btn__icon--danger">
                                                    <use xlink:href="#icon__square-cross" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div v-if="checkForInvalidAnswer(key,false)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="typeId === QUESTION_SEQUENCE_CORRECT" class="sequence-correct-answer">
                                <Draggable :list="answers" ghost-class="ghost">
                                    <div v-for="(item,key) in answers" v-bind:key="key" class="mb-2 answer-group answer-draggable d-flex">
                                        <div class="answer-ky col-md-6">
                                            <label class="form__label  form__label--block answer-draggable">{{ getTranslation('answerRu') }} <span class="required">*</span></label>
                                            <textarea :class="{'field--error' : checkForInvalidAnswer(key,true) && checkAnswer }" class="field field--full-width" v-model.trim="item.answerRu" style="height: 50px" />
                                            <div v-if="checkForInvalidAnswer(key,true)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                        </div>
                                        <div class="answer-ru input-group col-md-6">
                                            <label class="answer-draggable form__label  form__label--block">{{ getTranslation('answerKy') }} <span class="required">*</span> </label>
                                            <textarea :class="{'field--error' : checkForInvalidAnswer(key,false) && checkAnswer}" class="field field--80-width" v-model.trim="item.answerKy" style="height: 50px" />
                                            <div class="answer-actions float-lg-right ml-2">
                                                <a :title="getTranslation('delete')" @click="deleteAnswer(key)" :disabled="answers.length < 4" class="btn  btn--white  btn--square" href="javascript:void(0)">
                                                    <svg class="btn__icon  btn__icon--danger">
                                                        <use xlink:href="#icon__square-cross" />
                                                    </svg>
                                                </a>
                                                <a :title="getTranslation('move')" class="answer-draggable ml-1 btn  btn--white  btn--square" href="javascript:void(0)">
                                                    <img class="btn__icon answer-draggable" src="@/assets/img/icons/move-icon.png" :alt="getTranslation('move')">
                                                </a>
                                            </div>
                                            <div v-if="checkForInvalidAnswer(key,false)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                        </div>
                                    </div>

                                </Draggable>
                            </div>
                            <div v-if="typeId === QUESTION_CONFIRMITY" class="confirmity-answer">
                                <div class="mb-2 card answer-draggable row">
                                    <div class="card-body row">
                                        <div class="confirmity-group col-md-6">
                                            <Draggable :list="answers" ghost-class="ghost">
                                                <div v-for="(item,key) in answers" class="confirmity-item" v-bind:key="key">
                                                    <div class="answer-actions float-lg-right ml-3">
                                                        <a :title="getTranslation('delete')" @click="deleteAnswer(key)" :disabled="answers.length < 4" class="btn  btn--white  btn--square" href="javascript:void(0)">
                                                            <svg class="btn__icon  btn__icon--danger">
                                                                <use xlink:href="#icon__square-cross" />
                                                            </svg>
                                                        </a>
                                                        <a :title="getTranslation('move')" class="answer-draggable ml-3 btn  btn--white  btn--square" href="javascript:void(0)">
                                                            <img class="btn__icon answer-draggable" src="@/assets/img/icons/move-icon.png" :alt="getTranslation('move')">
                                                        </a>
                                                    </div>
                                                    <div class="answer-ky d-block">
                                                        <label class="form__label  form__label--block">{{ getTranslation('answerRu') }} <span class="required">*</span> </label>
                                                        <textarea :class="{'field--error' : checkForInvalidAnswer(key,true) && checkAnswer }" class="field field--full-width" v-model.trim="item.answerRu" style="height: 50px" />
                                                        <div v-if="checkForInvalidAnswer(key,true)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                                    </div>
                                                    <div class="answer-ky d-block">
                                                        <label class="form__label  form__label--block">{{ getTranslation('answerKy') }} <span class="required">*</span></label>
                                                        <textarea :class="{'field--error' : checkForInvalidAnswer(key,false) && checkAnswer}" class="field field--full-width" v-model.trim="item.answerKy" style="height: 50px" />
                                                        <div v-if="checkForInvalidAnswer(key,false)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                                    </div>
                                                </div>
                                            </Draggable>
                                        </div>
                                        <div class="confirmity-group col-md-6">
                                            <Draggable :list="confirmityAnswers" ghost-class="ghost">
                                                <div v-for="(item,key) in confirmityAnswers" class="confirmity-item" v-bind:key="key">
                                                    <div class="answer-actions float-lg-right ml-3">
                                                        <a :title="getTranslation('delete')" @click="deleteConfirmatyAnswer(key)" :disabled="confirmityAnswers.length < 4" class="btn  btn--white  btn--square" href="javascript:void(0)">
                                                            <svg class="btn__icon  btn__icon--danger">
                                                                <use xlink:href="#icon__square-cross" />
                                                            </svg>
                                                        </a>
                                                        <a :title="getTranslation('move')" class="answer-draggable  btn  btn--white  btn--square ml-3" href="javascript:void(0)">
                                                            <img class="btn__icon answer-draggable" src="@/assets/img/icons/move-icon.png" :alt="getTranslation('move')">
                                                        </a>
                                                    </div>
                                                    <div class="answer-ky d-block">
                                                        <label class="form__label  form__label--block">{{ getTranslation('answerRu') }} <span class="required">*</span> </label>
                                                        <textarea :class="{'field--error' : checkForConfirmityInvalidAnswer(key,true) && checkAnswer }" class="field field--full-width" v-model.trim="item.answerRu" style="height: 50px" />
                                                        <div v-if="checkForConfirmityInvalidAnswer(key,true)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                                    </div>
                                                    <div class="answer-ky d-block">
                                                        <label class="form__label  form__label--block">{{ getTranslation('answerKy') }} <span class="required">*</span></label>
                                                        <textarea :class="{'field--error' : checkForConfirmityInvalidAnswer(key,false) && checkAnswer}" class="field field--full-width" v-model.trim="item.answerKy" style="height: 50px" />
                                                        <div v-if="checkForConfirmityInvalidAnswer(key,false)" class="form__error">{{ getTranslation('requiredField') }}</div>
                                                    </div>
                                                </div>
                                            </Draggable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form__group mt-5">
                <button type="submit" class="btn btn--main">{{ getTranslation('save') }}</button>
                <router-link v-if="$route.params.id" :to="{ name: 'api.question.get',params:{id:$route.params.id} }" class="btn btn--main-outline">{{ getTranslation('cancel') }}</router-link>
                <router-link v-else-if="testId" :to="{ name: 'api.testing.get',params:{id:testId} }" class="btn btn--main-outline">{{ getTranslation('cancel') }}</router-link>
                <router-link v-else :to="{ name: 'api.testing.structure.getList' }" class="btn btn--main-outline">{{ getTranslation('cancel') }}</router-link>
            </div>
        </form>
    </div>
</template>

<script>

    import required from "vuelidate/lib/validators/required";
    import TestingSelectComponent from "@/components/TestingSelectComponent";
    import Draggable from 'vuedraggable';
    import ckeditorMixin from "@/components/mixins/Ckeditor";
    import questionMixin from "@/views/admin/questions/mixins/question";

    const SINGLE = 1;// Один правильный ответ
    const MULTIPLE = 2;// Несколько правильных ответов
    const CONFIRMITY = 3; // Установление соответствия
    const SEQUENCE_CORRECT = 4;// Правильный последовательность
    const FILL_IN = 5;// Заполнение

    export default {
        name: "QuestionCreateComponent",
        components: { TestingSelectComponent, Draggable },
        mixins: [questionMixin,ckeditorMixin],
        props: {
            action: {
                type: String,
                required: false,
                default: 'create',
            }
        },
        data() {
            return {
                trueAnswer: '',
                image: {
                    width: '',
                    height: '',
                    name: '',
                    imageUrl: '',
                    type: '',
                    extension: '',
                    base64: '',
                },
                file: { name: null },
                invalidAnswers: [],
                confirmityInvalidAnswers: [],
                SINGLE: SINGLE,
                MULTIPLE: MULTIPLE,
                CONFIRMITY: CONFIRMITY,
                SEQUENCE_CORRECT: SEQUENCE_CORRECT,
                FILL_IN: FILL_IN,
                checkAnswer: false,
                formTrueAnswers: {
                    trueAnswerKy: '',
                    trueAnswerRu: '',
                    descriptionRu: '',
                    descriptionKy: '',
                }
            }
        },
        created() {
            this.fetchFormOptions().then( () => {
                if ( this.$route.params.id ) {
                    this.fetchQuestion( this.$route.params.id, true ).then( () => {
                        this.getAnswers( this.typeId );
                    } );
                }
                else
                    this.initAnswers()
            } );

        },
        computed: {
            typeId() {
                return this.form.typeId;
            },
            questionID() {
                return this.$route.params.id;
            }
        },
        watch: {
            typeId: {
                immediate: true,
                handler( newVal, oldVal ) {

                    this.resetValidation();
                    this.initAnswers();

                    if ( newVal ) {
                        switch ( newVal ) {
                            case FILL_IN:
                                if ( this.questionID )
                                    this.getAnswers( FILL_IN );
                                else
                                    this.trueAnswer = [];
                                break;
                            case SEQUENCE_CORRECT:
                            case SINGLE:
                                if ( this.questionID )
                                    oldVal === MULTIPLE ? this.trueAnswer = '' : this.getAnswers( SINGLE );
                                else
                                    this.trueAnswer = '';

                                break;
                            case MULTIPLE:
                                if ( this.questionID )
                                    this.getAnswers( MULTIPLE );
                                else
                                    this.trueAnswer = [];
                                break;
                            case CONFIRMITY:
                                if ( this.questionID && oldVal === CONFIRMITY )
                                    this.getAnswers( CONFIRMITY );
                                else
                                    this.initAnswers();
                                break;
                        }
                    }
                }
            }
        },
        methods: {
            save() {
                this.form.testId = this.testId;

                if ( !this.checkAnswerValidation() ) {
                    this.$v.form.$touch();
                    return this.snotifyError( 'wrongFormMsg' );
                }

                this.$v.form.$touch();

                if ( this.$v.form.$invalid )
                    return this.snotifyError( 'wrongFormMsg' );

                if ( this.validateAnswers() ) {

                    if ( this.image.base64 )
                        this.form.photoBase64 = this.image.base64;

                    this.saveQuestion( this.questionID ).then( () => {
                        this.initAnswers();
                        this.resetForm();
                        this.$store.dispatch( 'test/incrementQuestionCount' );
                        if ( this.questionID ) {
                            this.snotifySuccess( 'updateSuccessMsg' );
                            this.$router.push( { name: 'api.question.get', params: { id: this.questionID } } );
                        }
                        else {
                            this.$emit( 'update-test' );
                            this.snotifySuccess( 'saveSuccessMsg' );
                        }
                        this.$v.form.$reset();
                    } ).catch(()=>{});
                }

            },

            addAnswer() {
                if ( this.typeId === CONFIRMITY && this.answers.length > this.confirmityAnswers.length ) {
                    this.confirmityAnswers.push( {
                        answerKy: '',
                        answerRu: '',
                    } );
                }
                else if ( this.typeId === CONFIRMITY ) {
                    this.confirmityAnswers.push( {
                        answerKy: '',
                        answerRu: '',
                    } );

                    this.answers.push( {
                        answerKy: '',
                        answerRu: '',
                        trueAnswer: 0,
                        trueAnswerKy: '',
                    } );
                }
                else if ( this.typeId === FILL_IN ) {
                    if ( this.answers.length < 1 )
                        this.answers.push( {
                            answerKy: '',
                            answerRu: '',
                            trueAnswer: 0,
                            trueAnswerKy: '',
                        } );
                }
                else
                    this.answers.push( {
                        answerKy: '',
                        answerRu: '',
                        trueAnswer: 0,
                        trueAnswerKy: '',
                    } );

            },

            deleteAnswer( index ) {
                if ( this.answers.length > index ) {

                    if ( this.typeId === FILL_IN && this.answers.length > 0 ) {
                        Swal.fire( {
                            title: this.getTranslation( 'areYouSure' ),
                            text: this.getTranslation( 'cantRevertMsg' ),
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonText: this.getTranslation( 'cancel' ),
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: this.getTranslation( 'ImSure' )
                        } ).then( ( result ) => {
                            if ( result.value ) {
                                this.answers.splice( index, 1 );
                                //removing true answer
                                if ( index === parseInt( this.trueAnswer ) )
                                    this.trueAnswer = '';
                            }
                        } );
                    }
                    else if ( this.typeId === SINGLE ) {
                        if ( this.answers.length > 2 ) {

                            Swal.fire( {
                                title: this.getTranslation( 'areYouSure' ),
                                text: this.getTranslation( 'cantRevertMsg' ),
                                icon: 'warning',
                                showCancelButton: true,
                                cancelButtonText: this.getTranslation( 'cancel' ),
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: this.getTranslation( 'ImSure' )
                            } ).then( ( result ) => {
                                if ( result.value ) {
                                    this.answers.splice( index, 1 );
                                    //removing true answer
                                    if ( index === parseInt( this.trueAnswer ) )
                                        this.trueAnswer = '';
                                }
                            } );
                        }
                    }
                    else {
                        if ( this.answers.length > 3 ) {

                            Swal.fire( {
                                title: this.getTranslation( 'areYouSure' ),
                                text: this.getTranslation( 'cantRevertMsg' ),
                                icon: 'warning',
                                showCancelButton: true,
                                cancelButtonText: this.getTranslation( 'cancel' ),
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: this.getTranslation( 'ImSure' )
                            } ).then( ( result ) => {
                                if ( result.value ) {
                                    this.answers.splice( index, 1 );
                                }
                            } );
                        }
                    }

                }
            },

            deleteConfirmatyAnswer( index ) {


                Swal.fire( {
                    title: this.getTranslation( 'areYouSure' ),
                    text: this.getTranslation( 'cantRevertMsg' ),
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: this.getTranslation( 'cancel' ),
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.getTranslation( 'ImSure' )
                } ).then( ( result ) => {
                    if ( result.value ) {
                        if ( this.confirmityAnswers.length > index )
                            this.confirmityAnswers.splice( index, 1 );

                        if ( this.confirmityInvalidAnswers[index] )
                            this.confirmityInvalidAnswers.splice( index, 1 );
                    }

                } );


            },

            initAnswers() {
                if ( !this.form.id ) {
                    this.answers = [];
                    let minN = 3;

                    if ( this.typeId === SINGLE )
                        minN = 2;
                    else if ( this.typeId === this.QUESTION_FILL_IN )
                        minN = 1;
                    else
                        minN = 3;

                    for ( let i = 0; i < minN; i++ ) {
                        this.answers.push( {
                            answerKy: '',
                            answerRu: '',
                            trueAnswer: 0,
                            trueAnswerKy: '',
                        } );
                    }


                    if ( this.typeId === this.QUESTION_CONFIRMITY ) {
                        this.confirmityAnswers = [];
                        for ( let i = 0; i < minN; i++ ) {
                            this.confirmityAnswers.push( {
                                answerKy: '',
                                answerRu: '',
                            } );
                        }
                    }
                }
            },

            getAnswers( typeId ) {
                this.answers = this.form.answers;
                switch ( typeId ) {
                    case this.QUESTION_FILL_IN:
                    case this.QUESTION_SINGLE:
                        this.trueAnswer = this.getSingleAnswer( this.form.answers );
                        break;
                    case this.QUESTION_MULTIPLE:
                        this.getMultipleAnswer( this.form.answers );
                        break;
                    case this.QUESTION_CONFIRMITY:
                        this.getConfirmityAnswers( this.form.answers, this.form.conformity );
                        break;
                }
            },

            getSingleAnswer( answers ) {

                for ( let i = 0; i < answers.length; i++ ) {
                    if ( answers[i].trueValue === 1 )
                        return i;
                }
            },

            getMultipleAnswer( answers ) {
                for ( let i = 0; i < answers.length; i++ ) {
                    if ( answers[i].trueValue === 1 )
                        answers[i].trueAnswer = true;
                    else
                        answers[i].trueAnswer = null;
                }
            },

            getConfirmityAnswers( answers, confirmityAnswers ) {

                this.confirmityAnswers = [];

                if ( confirmityAnswers.length < 1 )
                    this.initAnswers();
                else
                    for ( let answer of answers ) {
                        let arr = confirmityAnswers.filter( item => {
                            return item.id === answer.trueValue
                        } );

                        this.confirmityAnswers.push( arr[0] );
                    }

            },


            //########### check for answers ###############
            checkForInvalidAnswer( index, ru = true ) {
                if ( this.invalidAnswers.includes( index ) ) {
                    if ( this.typeId === FILL_IN ) {
                        if ( this.answers[index].answerRu.length < 1 && this.answers[index].answerKy.length < 1 )
                            return false;
                    }

                    if ( ru && this.answers[index].answerRu.length < 1 )
                        return true;
                    if ( !ru && this.answers[index].answerKy.length < 1 )
                        return true;
                }
                return false;
            },

            checkForConfirmityInvalidAnswer( index, ru = true ) {
                if ( this.typeId === CONFIRMITY ) {
                    if ( this.confirmityInvalidAnswers.includes( index ) ) {
                        if ( ru && this.confirmityAnswers[index].answerRu.length < 1 )
                            return true;
                        if ( !ru && this.confirmityAnswers[index].answerKy.length < 1 )
                            return true;
                    }
                    return false;
                }
            },

            checkAnswerValidation() {
                this.invalidAnswers = [];
                this.confirmityInvalidAnswers = [];

                switch ( this.typeId ) {
                    case FILL_IN:
                        this.minNumberOfQuestions = 0;
                        break;
                    case SINGLE:
                        this.minNumberOfQuestions = 2;
                        break;
                    default:
                        this.minNumberOfQuestions = 3;
                        break;
                }

                if ( this.answers.length < this.minNumberOfQuestions ) {
                    this.snotifyError( 'minNumberOfQuestion', this.minNumberOfQuestions, 4000 );
                    return false;
                }

                switch ( this.typeId ) {
                    case CONFIRMITY:
                        let k = 0;
                        for ( let item of this.answers ) {
                            this.answer = item;
                            this.$v.answer.$touch();
                            if ( this.$v.answer.$invalid )
                                this.invalidAnswers.push( k );

                            this.$v.answer.$reset();

                            this.answer = {
                                answerKy: '',
                                answerRu: '',
                                trueAnswer: 0,
                                trueAnswerKy: '',
                            };

                            k++;
                        }
                        return this.checkConfirmityValidation();
                    case FILL_IN:
                        let j = 0;
                        for ( let item of this.answers ) {
                            this.answer = item;
                            this.$v.answer.$touch();
                            if ( ( this.$v.answer.answerKy.$error && !this.$v.answer.answerRu.$invalid ) || ( !this.$v.answer.answerKy.$error && this.$v.answer.answerRu.$error ) )
                                this.invalidAnswers.push( j );

                            this.$v.answer.$reset();

                            this.answer = {
                                answerKy: '',
                                answerRu: '',
                                trueAnswer: 0,
                                trueAnswerKy: '',
                            };

                            j++;
                        }
                        break;
                    default:
                        let i = 0;
                        for ( let item of this.answers ) {
                            this.answer = item;
                            this.$v.answer.$touch();
                            if ( this.$v.answer.$invalid )
                                this.invalidAnswers.push( i );

                            this.$v.answer.$reset();

                            this.answer = {
                                answerKy: '',
                                answerRu: '',
                                trueAnswer: 0,
                                trueAnswerKy: '',
                            };

                            i++;
                        }
                        break;
                }


                this.checkAnswer = true;
                return this.invalidAnswers.length <= 0;
            },

            checkConfirmityValidation() {

                this.confirmityInvalidAnswers = [];
                if ( this.confirmityAnswers.length < this.minNumberOfQuestions ) {
                    this.snotifyError( 'minNumberOfQuestion', this.minNumberOfQuestions, 4000 );
                    return false;
                }

                let i = 0;
                for ( let item of this.confirmityAnswers ) {
                    this.answer = item;
                    this.$v.answer.$touch();
                    if ( this.$v.answer.$invalid ) {
                        this.confirmityInvalidAnswers.push( i );
                    }
                    this.$v.answer.$reset();

                    this.answer = {
                        answerKy: '',
                        answerRu: '',
                        trueAnswer: 0,
                        trueAnswerKy: '',
                    };

                    i++;
                }

                return this.confirmityInvalidAnswers.length <= 0;

            },

            //############ validation ####################

            validateAnswers() {
                switch ( this.typeId ) {
                    case SINGLE:
                        return this.validateSingleAnswer();
                    case MULTIPLE:
                        return this.validateMultipleAnswer();
                    case SEQUENCE_CORRECT:
                        return this.validateSequenceAnswer();
                    case CONFIRMITY:
                        return this.validateConfirmityAnswer();
                    case FILL_IN:
                        return this.validateFillInAnswer();
                }
            }
            ,
            validateSingleAnswer() {
                let trueAnswerIndex;
                if ( isNaN( this.trueAnswer ) || isNaN( parseInt( this.trueAnswer ) ) ) {
                    this.snotifyError( 'singleAnswerError' );
                    return false;
                }
                trueAnswerIndex = parseInt( this.trueAnswer );
                if ( this.answers.length <= trueAnswerIndex ) {
                    this.snotifyWarning();
                    return false;
                }

                if ( this.answers[trueAnswerIndex] ) {
                    let i = 0;
                    for ( let item of this.answers ) {
                        if ( this.questionID )
                            item.trueAnswer = i === trueAnswerIndex;
                        else
                            item.trueAnswer = i === trueAnswerIndex;
                        i++;
                    }
                }
                else {
                    this.snotifyWarning();
                    return false;
                }

                this.form.answers = this.answers;
                return true;
            },

            validateFillInAnswer() {
                if ( this.typeId === FILL_IN ) {

                    this.formTrueAnswers.trueAnswerKy = this.form.trueAnswerKy;
                    this.formTrueAnswers.trueAnswerRu = this.form.trueAnswerRu;
                    this.formTrueAnswers.descriptionRu = this.form.descriptionRu;
                    this.formTrueAnswers.descriptionKy = this.form.descriptionKy;

                    this.$v.formTrueAnswers.$touch();

                    if ( this.$v.formTrueAnswers.$invalid ) {
                        this.snotifyError( 'wrongFormMsg' );
                        return false;
                    }

                    let invalidData = false;
                    for ( let item of this.answers ) {
                        this.answer = item;
                        this.$v.answer.$touch();
                        if ( this.$v.answer.$invalid )
                            invalidData = true;

                        this.$v.answer.$reset();

                        this.answer = {
                            answerKy: '',
                            answerRu: '',
                            trueAnswer: 0,
                            trueAnswerKy: '',
                        };
                    }
                    if ( invalidData )
                        this.form.answers = [];
                    else
                        this.form.answers = this.answers;

                    return true;

                }
            },

            validateMultipleAnswer() {
                let trueAnswers = this.answers.filter( item => item.trueAnswer === true );
                if ( trueAnswers.length < 1 ) {
                    this.snotifyError( 'noAnswerError' );
                    return false;
                }
                if ( trueAnswers.length === 1 ) {
                    this.snotifyError( 'multipleAnswerError' );
                    return false;
                }

                this.form.answers = this.answers;

                return true;
            }
            ,
            validateSequenceAnswer() {
                this.form.answers = this.answers.map( item => {
                    item.trueAnswer = 1;
                    return item;
                } );
                return true;
            }
            ,
            validateConfirmityAnswer() {
                let i = 0;
                for ( let item of this.answers ) {
                    item.trueAnswer = this.confirmityAnswers[i].answerRu;
                    item.trueAnswerKy = this.confirmityAnswers[i].answerKy;
                    i++;
                }

                this.form.answers = this.answers;
                return true;
            }
            ,
            resetForm() {
                this.trueAnswer = '';
                this.image = { extension: '', height: '', width: '', name: '', base64: '', type: '', imageUrl: '' };
                this.formTrueAnswers = {
                    trueAnswerKy: '',
                    descriptionKy: '',
                    descriptionRu: '',
                    trueAnswerRu: '',
                };
                this.form = {
                    id: null,
                    questionKy: '',
                    questionRu: '',
                    section: '',
                    sectionKy: '',
                    photoBase64: null,
                    photoUrl: '',
                    trueAnswerKy: '',
                    trueAnswerRu: '',
                    status: true,
                    typeId: 1,
                    testId: this.testId,
                    answers: [],
                };
            }
            ,
            resetValidation() {
                this.invalidAnswers = [];
                this.confirmityInvalidAnswers = [];
                this.$v.$reset();
            },

            async uploadPhoto( e ) {
                if ( e.target.files.length > 0 && e.target.files[0].type.indexOf( 'image/' ) > -1 ) {

                    let file = e.target.files[0];

                    await this.getImageInfo( file ).then( imageInfo => {
                        this.image = imageInfo;
                        this.form.photoUrl = imageInfo.imageUrl;
                    } );
                }
                else
                    this.snotifyError( 'fileFormatErrorMsg', '.png,.jpeg,...' );
            },

            clearFillinAnswers( lang = 'ru' ) {
                Swal.fire( {
                    title: this.getTranslation( 'areYouSure' ),
                    text: this.getTranslation( 'cantRevertMsg' ),
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: this.getTranslation( 'cancel' ),
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.getTranslation( 'ImSure' )
                } ).then( ( result ) => {
                    if ( result.value ) {
                        if(lang==='ru')
                            this.answers[0].answerRu='';
                        else
                            this.answers[0].answerKy='';
                    }
                } );
            },

            clearFile() {
                if ( this.form.photoUrl ) {
                    Swal.fire( {
                        title: this.getTranslation( 'areYouSure' ),
                        text: this.getTranslation( 'cantRevertMsg' ),
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: this.getTranslation( 'cancel' ),
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: this.getTranslation( 'ImSure' )
                    } ).then( ( result ) => {
                        if ( result.value ) {
                            this.form.photoBase64 = 'reset';
                            this.form.photoUrl = '';
                            if ( this.image.base64 || this.image.name ) {
                                this.image = { extension: '', height: '', width: '', name: '', base64: '', type: '', imageUrl: '' };
                            }
                        }
                    } );
                }
            }
        },
        validations: {
            form: {
                questionKy: {
                    required
                }
                ,
                questionRu: {
                    required
                }
                ,
                status: {
                    required
                }
                ,
                typeId: {
                    required
                }
                ,
                testId: {
                    required
                }
                ,
            },

            answer: {
                answerKy: {
                    required
                },
                answerRu: {
                    required
                },
            },

            answers: {
                required
            },

            formTrueAnswers: {
                trueAnswerKy: {
                    required
                },
                trueAnswerRu: {
                    required
                },
            }

        }
    }
</script>

<style scoped>
    .answer-ky {
        min-width: 570px !important;
    }

    .answer-ru {
        margin-left: 10px;
        min-width: 590px !important;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .answer-group {
        display: inline-flex !important;
    }

    .field--90-width {
        width: 90% !important;
    }

    .field--80-width {
        width: 80% !important;
    }

    .question-count-badge {
        padding: 8px 20px;
        font-size: 15px;
    }

    .answer-draggable {
        cursor: move !important;
    }

    .confirmity-item {
        margin-bottom: 20px !important;
        border: 1px dashed #28529B;
        border-radius: 4px;
        padding: 10px;
    }

    .fill-in-answer {
        margin-top: 40px;
    }

    .card {
        border: none;
    }
</style>
